import React, { useState } from "react";
import './navbar.scss';
import linkedin from './../../image/linkedin.svg';
import behance from './../../image/behance.svg';
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from 'react-scroll';

const Navbar: React.FC = () => {

  const location = useLocation();

  const getLinkClass = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  const [isMenuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <header className="">
        <div className="wrapper">
        <div className="header-wrapper">
          <Link to="/" className="logo">
              <span className="name">Alex</span>
              <span className="surname">Puliatti</span>
            </Link>
            <div className="hamburger-menu" onClick={()=>setMenuOpen(!isMenuOpen)}>
              <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.500999H19M1 6.501H19M1 12.501H19" stroke="black" stroke-width="0.8125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          
          <div className={(isMenuOpen ? 'visible' : '') + " navbar-links"}>
            <Link to="/" className={getLinkClass('/') + " navbar-link"}>Homepage</Link>
            <Link to="/about" className={getLinkClass('/about') + " navbar-link"}>About me</Link>
            <Link to="/portfolio"  className={getLinkClass('/portfolio') + " navbar-link"}>Portfolio</Link>
            <div className="socialIcons">
            <Link to="https://www.linkedin.com/in/alexpuliatti/" className="navbar-link social">
              <img className="linkedin-icon" src={linkedin} alt="" />
            </Link>
            <Link to="https://www.behance.net/alexpuliatti2" className="navbar-link social">
               <img className="behance-icon" src={behance} alt="" />
            </Link>
            </div>
            
            <Link to="/contact" className="cta">Get in touch</Link>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;